import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SheetLoader({ label = 'Загружаем лист…' }) {
    return (_jsxs("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
            padding: 24,
        }, children: [_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'flex-start' }, children: [_jsx("div", { className: "ql-bar ql-bar-1", style: { width: 72, height: 9, borderRadius: 5, background: '#93B4F5' } }), _jsx("div", { className: "ql-bar ql-bar-2", style: { width: 48, height: 9, borderRadius: 5, background: '#B9CFF9' } }), _jsx("div", { className: "ql-bar ql-bar-3", style: { width: 60, height: 9, borderRadius: 5, background: '#DBE7FC' } })] }), _jsx("div", { className: "ql-fade", style: { fontSize: 12.5, color: '#64748B' }, children: label })] }));
}
